module.exports = __webpack_public_path__ + "img/193.880d4d40.jpg";